import { insertRule } from 'glamor';

export default function applyRootStyles() {
  insertRule(`html, body, div, span, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  abbr, address, cite, code,
  del, dfn, em, img, ins, kbd, q, samp,
  small, strong, sub, sup, var,
  b, i,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section, summary,
  time, mark, audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
  }`);

  insertRule(`body {
    line-height:1;
    padding-right:0px !important;
    margin-right:0px !important;
  }`);

  insertRule(`article,aside,details,figcaption,figure,
  footer,header,hgroup,menu,nav,section {
    display:block;
  }`);

  insertRule(`nav ul {
    list-style:none;
  }`);

  insertRule(`
  @keyframes fadeIn {
    0% { opacity: 0; }
    50% { opacity: 0; }
    100% { opacity: 100%; }
  }

  .fade-in {
    animation: fadeIn 150ms ease-in;
    animation-iteration-count: 1;
  }`);

  insertRule(`a {
    margin:0;
    padding:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
  }`);

  insertRule(`table {
    border-collapse:collapse;
    border-spacing:0;
  }`);

  insertRule(`hr {
    display:block;
    height:1px;
    border:0;
    border-top:1px solid #cccccc;
    margin:1em 0;
    padding:0;
  }`);

  insertRule(`input, select {
    vertical-align:middle;
  }`);

  insertRule(`html {
    box-sizing: border-box;
  }`);

  insertRule(`*, *:before, *:after {
    box-sizing: inherit;
  }`);

  insertRule(`html,
  body {
    margin: 0;
    padding: 0;
    font-family: 'Helvetica', Arial, sans-serif;
    font-size: 16px;
    background: white;
  }`);

  insertRule(`input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 10000px white inset;
  }`);

  insertRule(`body.modal-open {
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: fixed;
  }`);

  insertRule(`@media (min-width: 701px) {
    body.modal-open {
      position: absolute;
      overflow-y: scroll;
    }
  }`);

  insertRule(`#nprogress {
    pointer-events: none;
  }`);

  insertRule(`#nprogress .bar {
    background: #f00;

    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;

    width: 100%;
    height: 2px;
  }`);

  insertRule(`#nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    opacity: 1.0;
    transform: rotate(3deg) translate(0px, -4px);
  }`);
}



// WEBPACK FOOTER //
// ../src/client/utils/applyRootStyles.js